module.exports = __webpack_public_path__ + "static/media/IMG_1225.a883cf02.jpg";